import React from 'react';
import { Helmet } from 'react-helmet-async';
// ✅ Added Helmet
import './ContactUsPage.css';

const ContactPage = () => {
  return (
    <div className="contact-wrapper">
      {/* ✅ SEO Meta Tags */}
      <Helmet>
        <title>Contact Us | binzal - Support & Assistance</title>
        <meta name="description" content="Need help with your binzal order or service? Contact us for support, queries, or feedback – we’re here to assist you across Bihar." />
        <meta name="keywords" content="binzal contact, customer support Bihar, grocery delivery help, binzal phone email address" />
        <meta name="robots" content="index, follow" />
        <meta property="og:title" content="Contact binzal | Support Across Bihar" />
        <meta property="og:description" content="Reach out to binzal for help with groceries, vegetables, or stationery delivery in Bihar." />
        <meta property="og:type" content="website" />
        <meta name="twitter:card" content="summary" />
      </Helmet>

      <section className="contact-banner">
        <div className="banner-overlay"></div>
        <img
          src="https://cdn.pixabay.com/photo/2023/11/30/17/02/business-8422066_1280.jpg"
          alt="Grocery Store Contact Banner"
          className="banner-image"
        />
        <div className="banner-content">
          <h1>Contact Us</h1>
          <p>Can’t find what you're looking for? Reach out — our support team is here to make things easier for you.</p>
        </div>
      </section>

      <section className="contact-info-section">
        <div className="info-block">
          <i className="bi bi-geo-alt-fill info-icon"></i>
          <h3>Corporate Office</h3>
          <p>16th Cross, 18th main, Sector-4, HSR Layout, Bangalore, Karnataka, India</p>
        </div>
        <div className="info-block">
          <i className="bi bi-telephone-fill info-icon"></i>
          <h3>Phone</h3>
          <p>+91-70797 70897</p>
        </div>
        <div className="info-block">
          <i className="bi bi-envelope-fill info-icon"></i>
          <h3>E-mail</h3>
          <p>support@binzal.com</p>
        </div>
      </section>
    </div>
  );
};

export default ContactPage;
